export const initialTeams = [
  {
    id: "1",
    name: "Pharmacy Team",
    description:
      "Main pharmacy staff responsible for prescriptions and consultations",
    members: ["1", "2"],
    pharmacies: ["1", "2", "3"],
    color: "#3b82f6",
    active: true,
  },
  {
    id: "2",
    name: "Management Team",
    description: "Administrative and management staff",
    members: ["3", "4"],
    pharmacies: ["1", "2", "3", "4", "5"],
    color: "#10b981",
    active: true,
  },
  {
    id: "3",
    name: "Specialist Team",
    description: "Specialists for travel health and vaccinations",
    members: ["1"],
    pharmacies: ["2", "4"],
    color: "#f59e0b",
    active: true,
  },
];
